/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:cc51d0c5-72fc-4331-bc47-b032dd55454f",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_nJhuiGOEE",
    "aws_user_pools_web_client_id": "5defembosbm2ph555mev14gfto",
    "oauth": {}
};


export default awsmobile;
